import React from 'react';
import { UserRole } from '@features/settings/types/settings.types';
import { useProfile } from '@shared/hooks/useProfile';
import AuthenticatedLayout from '@shared/layouts/AuthenticatedLayout';
import SupportAdminDashboard from '../components/SupportAdminDashboard';
import { SupportProvider, SupportChatBubble } from '../';

/**
 * Main page for the Support feature
 * Only accessible to admins (role 0)
 */
const SupportPage: React.FC = () => {
  const { user } = useProfile();

  // Only admins can access this page
  if (!user || user.role !== UserRole.ADMIN) {
    return (
      <div className="flex flex-col items-center justify-center h-screen">
        <h1 className="text-2xl font-bold mb-2">Unauthorized Access</h1>
        <p className="text-gray-600 dark:text-gray-400">
          You don't have permission to access this page.
        </p>
      </div>
    );
  }

  return (
    <AuthenticatedLayout className="h-full overflow-hidden">
      <SupportAdminDashboard />
    </AuthenticatedLayout>
  );
};

export default SupportPage;
